import type { Status } from '@/common/db-typebox';
import type {
  Acidity,
  AgingPotential,
  Body,
  FinishLength,
  Sweetness,
  Tannins,
  WineType,
} from '@/common/generated/wine-product.typebox';

export const WineTypes: WineType[] = [
  'red',
  'white',
  'sparkling',
  'rosé',
  'dessert',
  'sherry',
  'port',
  'orange',
  'other',
];

export const StatusValues: Status[] = ['enabled', 'disabled'];

export const BODY_OPTIONS: Body[] = ['light', 'medium', 'full'];
export const ACIDITY_OPTIONS: Acidity[] = ['low', 'medium', 'high'];
export const TANNINS_OPTIONS: Tannins[] = ['soft', 'medium', 'firm'];
export const SWEETNESS_OPTIONS: Sweetness[] = ['dry', 'off-dry', 'sweet'];
export const FINISH_LENGTH_OPTIONS: FinishLength[] = [
  'short',
  'medium',
  'long',
];
export const AGING_POTENTIAL_OPTIONS: AgingPotential[] = [
  'drink now',
  'short term',
  'medium term',
  'long term',
];
